import BaseModel from './BaseModel'
import {db} from '../utilities'

export default class Aggregations extends BaseModel {
    constructor (id: string) {
        super(db.collection('analytics_data'))
    }
}